import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

export const TopWrapper = styled.div`
  line-height: 19px;
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TotalMails = styled.div`
  font-weight: 600;
  display: flex;
  align-items: center;

  & > svg {
    margin-right: 10px;
  }

  & > span {
    text-transform: uppercase;
  }

  @media (max-width: 340px) {
    display: none;
    }
  }
`

export const TotalMailsMobile = styled.div`
  display: none;
  @media (max-width: 340px) {
    display: flex;
    font-weight: 600;
    align-items: center;
    & > svg {
      margin-left: 4px;
    }
  }
`

export const ActionBar = styled.div`
  width: 100%;
  background: white;
  padding: 24px 24px 10px 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media(max-width: ${measures.mobileThreshold}px) {
    background: ${colors.white};
    padding: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 101;
  }
`
